export const DROPBOX_SATELLITE_GALLERY_MANIFEST = {
  '2025-2026': {
    Glasgow: [
      {
        fileName: 'glasgow-2025-2026-01.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AI7XzL1bhEGJa4d8VBX58BM/Glasgow/glasgow-2025-2026-01.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'glasgow-2025-2026-02.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AC0Fwi0odENFxVRcPGUnmzI/Glasgow/glasgow-2025-2026-02.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'glasgow-2025-2026-03.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AMnXNd6EcLF-xzaGsRSguKU/Glasgow/glasgow-2025-2026-03.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'glasgow-2025-2026-04.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AMrMj5ceQQA4UXQX7TRU1L8/Glasgow/glasgow-2025-2026-04.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'glasgow-2025-2026-05.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AO-QAu7xT4NzaB8xaIn6HS0/Glasgow/glasgow-2025-2026-05.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'glasgow-2025-2026-06.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AJAIndyb76z6WvpWJtjVkZw/Glasgow/glasgow-2025-2026-06.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'glasgow-2025-2026-07.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ADU3-vsQuhOn9EWNRuhwjQo/Glasgow/glasgow-2025-2026-07.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'glasgow-2025-2026-08.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ANmuxTSYwWWIgZpaiRywv2M/Glasgow/glasgow-2025-2026-08.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'glasgow-2025-2026-09.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AEHDyGwLZ_GnSsSxFLZMOak/Glasgow/glasgow-2025-2026-09.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'glasgow-2025-2026-11.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ABWQeW9UfoL_d9OyAv5cc_8/Glasgow/glasgow-2025-2026-11.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
    ],
    Guildford: [
      {
        fileName: 'guildford-2025-2026-01.heic',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/APnpb3t9XRHO-P3Ygx41ZWM/Guildford/guildford-2025-2026-01.heic?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'guildford-2025-2026-01.jpg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AOhgssV9c6f8CaAMwvpTCt4/Guildford/guildford-2025-2026-01.jpg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'guildford-2025-2026-02.heic',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AK1aNju1jta0aQb2HtIc4LM/Guildford/guildford-2025-2026-02.heic?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'guildford-2025-2026-02.jpg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AFsXGwinuAGZ5-nBwkVHlNc/Guildford/guildford-2025-2026-02.jpg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'guildford-2025-2026-03.heic',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ADd08GvIFy4N8WrMe5m48o0/Guildford/guildford-2025-2026-03.heic?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'guildford-2025-2026-03.jpg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AAtXvgwbJOcT6mEKSBNpf68/Guildford/guildford-2025-2026-03.jpg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'guildford-2025-2026-04.heic',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ALEQq2sV6YwUl6t9A8f73Nk/Guildford/guildford-2025-2026-04.heic?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'guildford-2025-2026-05.jpg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AO3-qFIVZ4LsBS-rXvfEvmg/Guildford/guildford-2025-2026-05.jpg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'guildford-2025-2026-06.jpg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ABLCOPl0cZSbDHkHEjvsgMc/Guildford/guildford-2025-2026-06.jpg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'guildford-2025-2026-07.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ACGlDXfjz99z9wF4h4nQ6JE/Guildford/guildford-2025-2026-07.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
    ],
    Merton: [
      {
        fileName: 'merton-2025-2026-01.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/APE5jYSLmankR43cadBVs7U/Merton/merton-2025-2026-01.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'merton-2025-2026-02.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AIq-AGf3XtiKJKGPFZAvPCY/Merton/merton-2025-2026-02.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'merton-2025-2026-03.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AO4KgyJBqk3zUb9etfh8frw/Merton/merton-2025-2026-03.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'merton-2025-2026-04.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AC7FpPUOmXaZoyy15TJsWzQ/Merton/merton-2025-2026-04.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'merton-2025-2026-05.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AI_Ej-mJd1Cm3tE7U37DTBk/Merton/merton-2025-2026-05.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'merton-2025-2026-06.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AHf_abkKbIKQ_2NzFk3VtT4/Merton/merton-2025-2026-06.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'merton-2025-2026-07.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AK0sTWD4uyVFTMuAntfoehQ/Merton/merton-2025-2026-07.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'merton-2025-2026-08.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/APEo4M6-eAWqFuz6g9ybLKI/Merton/merton-2025-2026-08.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'merton-2025-2026-09.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AGpq_MtjqZULyQ2kOvlESjM/Merton/merton-2025-2026-09.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'merton-2025-2026-10.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ADfkbumJ5pxuK7MxOkvOlD8/Merton/merton-2025-2026-10.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
    ],
    Northampton: [
      {
        fileName: 'northampton-2025-2026-01.jpg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AMf_1kUHTL03RDABnuLMfME/Northampton/northampton-2025-2026-01.jpg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'northampton-2025-2026-02.jpg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ADq5f8p9C7NrCZb9451B1Nw/Northampton/northampton-2025-2026-02.jpg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'northampton-2025-2026-03.jpg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AKbUWDvIgwpedIJaNZ-NUYo/Northampton/northampton-2025-2026-03.jpg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'northampton-2025-2026-04.jpg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ACpIuRBGfCQbuDoxfDYMbrQ/Northampton/northampton-2025-2026-04.jpg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'northampton-2025-2026-05.jpg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AOsdgsEFjbD9jfZxXONmw2I/Northampton/northampton-2025-2026-05.jpg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
    ],
    Richmond: [
      {
        fileName: 'richmond-2025-2026-01.jpg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AHpq1_QO88Ah-YTEO0St88Q/Richmond/richmond-2025-2026-01.jpg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
    ],
    Stratford: [
      {
        fileName: 'stratford-2025-2026-01.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AFysVp8ePK8kXsAcdaKoY1A/Stratford/stratford-2025-2026-01.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'stratford-2025-2026-02.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AEWqvfOCFAZ7TqYljwgjLnU/Stratford/stratford-2025-2026-02.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'stratford-2025-2026-03.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ACZCWgZ43-5drooXaenBMFQ/Stratford/stratford-2025-2026-03.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'stratford-2025-2026-04.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AOlynRocKSoyk2OlcN1lk6s/Stratford/stratford-2025-2026-04.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'stratford-2025-2026-05.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AO3CiCkq2LOdG2HDEOpVZU4/Stratford/stratford-2025-2026-05.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'stratford-2025-2026-06.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AJ6RrYBdcbvTsM-dayqse6Q/Stratford/stratford-2025-2026-06.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'stratford-2025-2026-07.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ADCgqwQtcCkAqP9mkXV4-lc/Stratford/stratford-2025-2026-07.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'stratford-2025-2026-08.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AGgEhSwxguP5zwvWJutzg9Y/Stratford/stratford-2025-2026-08.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'stratford-2025-2026-09.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AKy6I5okQbVAwwvRMJ3F62c/Stratford/stratford-2025-2026-09.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'stratford-2025-2026-10.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AD7P6sn8gZgkQBvsuJwOLF0/Stratford/stratford-2025-2026-10.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
    ],
    Wilberforce: [
      {
        fileName: 'wilberforce-2025-2026-01.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AEDDhRkUbvyE-QtQiGnneL0/Wilberforce/wilberforce-2025-2026-01.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'wilberforce-2025-2026-02.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AKQ7D6unyMuwiPkkTTQ5LlQ/Wilberforce/wilberforce-2025-2026-02.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'wilberforce-2025-2026-03.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AIRpzwm8y5EE79EcSc5nqD0/Wilberforce/wilberforce-2025-2026-03.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'wilberforce-2025-2026-04.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ANQ3WTUvaeA6T2rbAcpZI-A/Wilberforce/wilberforce-2025-2026-04.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'wilberforce-2025-2026-05.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AOCJCkJYVNQRhBQcgH4Xk1c/Wilberforce/wilberforce-2025-2026-05.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'wilberforce-2025-2026-06.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AOls5kvHz5iHk5xgo7T1hso/Wilberforce/wilberforce-2025-2026-06.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'wilberforce-2025-2026-07.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ACZxncEU9NT1QItVO_I1uHk/Wilberforce/wilberforce-2025-2026-07.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'wilberforce-2025-2026-08.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ABx-4lVUEHWQeRIHNiFXSiE/Wilberforce/wilberforce-2025-2026-08.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'wilberforce-2025-2026-09.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AL8OH9bDHfQGqouRe69f3Ms/Wilberforce/wilberforce-2025-2026-09.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'wilberforce-2025-2026-10.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AFn2NbQkbrGF6bgpsRthEy8/Wilberforce/wilberforce-2025-2026-10.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'wilberforce-2025-2026-11.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AOlo8PB1VtNjPO4m6Af_7aA/Wilberforce/wilberforce-2025-2026-11.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'wilberforce-2025-2026-12.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AI6S_oMYRbfALN2Io8GET5I/Wilberforce/wilberforce-2025-2026-12.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'wilberforce-2025-2026-13.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AGAg2W_hiYpeLk19lDW6bo8/Wilberforce/wilberforce-2025-2026-13.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'wilberforce-2025-2026-14.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AKbf2TNwbVw1-GqbVV3hlnc/Wilberforce/wilberforce-2025-2026-14.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'wilberforce-2025-2026-15.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AHagTGG--zyGOmIlLrKZj2g/Wilberforce/wilberforce-2025-2026-15.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'wilberforce-2025-2026-16.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ANIuRmTqZEXDXdFuN1D25BA/Wilberforce/wilberforce-2025-2026-16.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
    ],
    Woking: [
      {
        fileName: 'woking-2025-2026-01.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AIjYKFXJtZWHp7l9NFg8Gwc/Woking/woking-2025-2026-01.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'woking-2025-2026-02.png',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/APWwiLG6K_U6I6dG-nrLcGQ/Woking/woking-2025-2026-02.png?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'woking-2025-2026-04.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AJYQBmMA8Ri_4RMSrbBbJ84/Woking/woking-2025-2026-04.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'woking-2025-2026-05.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AMhmFNrYrr1KyUsNmFDNmS4/Woking/woking-2025-2026-05.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'woking-2025-2026-06.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/ABPYTAJb5yQ8Ew907-dvAJU/Woking/woking-2025-2026-06.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
      {
        fileName: 'woking-2025-2026-07.jpeg',
        sharedUrl:
          'https://www.dropbox.com/scl/fo/2gpbl67x5925j0hy4m9zu/AIuJKNUbvgvwvhDMPf1mgA0/Woking/woking-2025-2026-07.jpeg?rlkey=a41jdzdthw7n3hyzlqf0hiqua&dl=0',
      },
    ],
  },
};
